import { Component, OnInit } from '@angular/core';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { ChartType, ChartDataSets, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { MatDialog } from '@angular/material/dialog';
import { KpiDialogComponent } from '../../../kpi-dialog/kpi-dialog.component';

@Component({
  selector: 'app-kpi-evaluation',
  templateUrl: './kpi-evaluation.component.html',
  styleUrls: ['./kpi-evaluation.component.scss']
})
export class KpiEvaluationComponent implements OnInit {

  public city = history.state.city;
  public kpi = history.state.kpi;

  public data: any = [];
  public kpis: any = [];
  public expanded: boolean = false;
  public actionName: string = '';
  public actions: any = [];
  public scores: any = [];
  public allowed: boolean;
  public is09: boolean = false;
  public is63: any = { Baseline: [], M24: [], M36: [], M42: [] };
  public is43: boolean = false;
  public is44: boolean = false;
  public is30: boolean = false;
  public count: number = 0;
  public username: string;
  public kpi9results: string = '';
  public kpi9notes: string = 'NOTE: <b>Food deserts in FUSILLI</b> are defined as geographic areas where access of residents to alternative production and consumption spaces such as local food markets, food gardens, community kitchens, consumer cooperatives etc. is out of walkable distance (being 400m for disadvantage people or 800m for adults).';
  public kpi30notes: string = 'The result shows the change in price of local products vs non-local products (%)';
  //Chart properties setup
  barChartType: ChartType = 'bar';
  barChartLabels: Label[] = ["Baseline", "M24", "M36", "M42"];
  barChartOptions: ChartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 100
        }
      }]
    }
  }

  barChartOption43: ChartOptions = {  // kpi 43 max value should be 10
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 10
        }
      }]
    }
  }

  barChartOption44: ChartOptions = {  // kpi 44 max value should be 20
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 20
        }
      }]
    }
  }

  public chartColors: any[] = [
    {
      backgroundColor: ["#3498DB", "#3498DB", "#3498DB", "#3498DB"],
      hoverBackgroundColor: ["#85C1E9", "#85C1E9", "#85C1E9", "#85C1E9"]
    },
    {
      backgroundColor: ["#89c2d9", "#89c2d9", "#89c2d9", "#89c2d9"],
      hoverBackgroundColor: ["#a9d6e5", "#a9d6e5", "#a9d6e5", "#a9d6e5"]
    },
    {
      backgroundColor: ["#468faf", "#468faf", "#468faf", "#468faf"],
      hoverBackgroundColor: ["#61a5c2", "#61a5c2", "#61a5c2", "#61a5c2"]
    },
    {
      backgroundColor: ["#2a6f97", "#2a6f97", "#2a6f97", "#2a6f97"],
      hoverBackgroundColor: ["#2c7da0", "#2c7da0", "#2c7da0", "#2c7da0"]
    },
    {
      backgroundColor: ["#01497c", "#01497c", "#01497c", "#01497c"],
      hoverBackgroundColor: ["#014f86", "#014f86", "#014f86", "#014f86"]
    },
    {
      backgroundColor: ["#012a4a", "#012a4a", "#012a4a", "#012a4a"],
      hoverBackgroundColor: ["#013a63", "#013a63", "#013a63", "#013a63"]
    },
    {
      backgroundColor: ["#72efdd", "#72efdd", "#72efdd", "#72efdd"],
      hoverBackgroundColor: ["#80ffdb", "#80ffdb", "#80ffdb", "#80ffdb"]
    },
  ];

  barChartData: any[] = [];
  public kpiScores: ChartDataSets[] = []
  public safeBaseUrl: any;
  public safeAllUrl: any;
  public safeTableUrl: any;
  isLoading = true;
  imageLoadCount = 0;
  totalImages = 3; // safeBaseUrl, safeAllUrl, and safeTableUrl

  constructor(private keycloak: KeycloakService, private req: HttpRequestsService<any>, private router: Router, public dialog: MatDialog) {

  }

  ngOnInit(): void {
    if (this.kpi.substring(0, 2) === '09') {
      this.is09 = true;
    }

    this.safeBaseUrl = `assets/img/kpi9/${this.city}_base.jpg`;
    this.safeAllUrl = `assets/img/kpi9/${this.city}_all.jpg`;
    this.safeTableUrl = `assets/img/kpi9/${this.city}_table.png`;

    const keycloakInstance = this.keycloak.getKeycloakInstance();
    if (keycloakInstance.authenticated) {
      this.keycloak.loadUserProfile().then(profile => {
        this.username = profile.username  //get username
      })
    }

    if (this.kpi.substring(0, 2) === '43' || this.kpi.substring(0, 2) === '57') {
      this.is43 = true;
    }

    if (this.kpi.substring(0, 2) === '30') {
      this.is30 = true;
    }

    if (this.kpi.substring(0, 2) === '44') {
      this.is44 = true;
    }

    if (this.kpi.substring(0, 2) === '09') {

      switch (this.city) {
        case ('Athens'): {
          this.kpi9results = 'In Athens, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 25.6% of the total LL area to 14.4%</b>. This analysis highlights the <b>positive impact</b> of alternative production and consumption spaces in improving healthy, sustainable and local food accessibility in the city.'
          break;
        }
        case ('Castelo Branco'): {
          this.kpi9results = 'In Castelo Branco, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 1.1% of the total LL area to 0.9%</b>. The Castelo Branco Living Lab, representing the Beira Baixa region, spans a large area with a sparse population. Besides the already low rate of food deserts before the project, FUSILLI’s efforts have had a <b>limited impact</b> on reducing these areas in the region. This modest effect can be attributed to the concentration of actions within already existing facilities and zones, rather than expanding into new areas.'
          break;
        }
        case ('Differdange'): {
          this.kpi9results = 'In Differdange, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 5% of the total LL area to 1.8%</b>. This analysis highlights the <b>positive impact</b> of alternative production and consumption spaces in improving healthy, sustainable and local food accessibility in the city.'
          break;
        }
        case ('Kolding'): {
          this.kpi9results = "In Kolding, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 7.1% of the total LL area to 6.8%</b>. The FUSILLI project's efforts have had a <b>limited impact</b> on reducing these areas. This modest effect can be attributed to the concentration of actions within already existing facilities and zones, rather than expanding into new areas."
          break;
        }
        case ('Kharkiv'): {
          this.kpi9results = "In Kharkiv, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 10% of the total LL area to 9.3%</b>. The <b>challenging situation</b> in Kharkiv due to the war hampers the creation of alternative production and consumption spaces where the population can feel secure. Nevertheless, the goodwill and efforts of Kharkiv's residents have <b>discreetly increased the accessibility</b> of healthy, local, and sustainable products, thereby reducing food deserts."
          break;
        }
        case ('Nilufer-Bursa'): {
          this.kpi9results = 'In Nilüfer, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 3.5% of the total LL area to 2.5%</b>. Besides the already low rate of food deserts before the project, FUSILLI’s efforts have had a <b>limited impact</b> on reducing these areas in the city. This modest effect can be attributed to the concentration of actions within already existing facilities and zones, rather than expanding into new areas. border area when considering <b>800m accessibility</b> from NIL AKIs.'
          break;
        }
        case ('Rijeka'): {
          this.kpi9results = 'In Rijeka, <b>food deserts</b> from alternative production and consumption spaces have <b>remained unchanged before and after FUSILLI Project with 16.4%</b>. The <b>lack of impact</b> on improving accessibility to Alternative Production and Consumption Spaces in the city LL is attributed to the concentration of actions and improvement of processes within already existing facilities and zones, rather than expanding into new areas.'
          break;
        }
        case ('Rome'): {
          this.kpi9results = 'In Rome, <b>food deserts</b> from alternative production and consumption spaces have <b>remained unchanged before and after FUSILLI Project with 8%</b>. The <b>lack of impact</b> on improving accessibility to alternative production and consumption spaces in the huge LL of Rome is attributed to the concentration of actions and <b>improvement of processes within already existing facilities</b> and zones, rather than expanding into new areas.'
          break;
        }
        case ('San Sebastian'): {
          this.kpi9results = 'In San Sebastian, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 14.2% of the total LL area to 2.1%</b>. This analysis highlights the positive impact of alternative production and consumption spaces in improving healthy, sustainable and local food accessibility in San Sebastian.'
          break;
        }
        case ('Tampere'): {
          this.kpi9results = "In Tampere, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 18.9% of the total LL area to 18.5%</b>. FUSILLI project's efforts have had a <b>limited impact</b> on reducing these areas in the city. This modest effect can be attributed to the concentration of actions within already existing facilities and zones, rather than expanding into new areas."
          break;
        }
        case ('Turin'): {
          this.kpi9results = 'In Mirafiori district in Turin, <b>food deserts</b> from alternative production and consumption spaces have <b>decreased from 1.3% of the total LL area to 0.6%</b>. The compact size of the LL in Turin, combined with the high density of alternative consumption spaces make the Mirafiori District in Turin a <b>model for ensuring</b> healthy, local, and sustainable food security and <b>accessibility</b>.'
          break;
        }
      }
    }

    this.req.getCityEvaluationKpis(this.city).subscribe((res) => {
      this.data = res;
      this.data.forEach(element => {
        element.expanded = false;
      });
    });
    if (this.keycloak.getUserRoles().includes('MODERATOR')) {
      this.allowed = true;
    } else {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      if (keycloakInstance.authenticated) {
        this.keycloak.loadUserProfile().then(profile => {
          if (profile['attributes'].City[0] == this.city) {
            this.allowed = true;
          } else {
            this.allowed = false;
          }
        });
      } else {
        this.allowed = false;
      }
    }
    if (this.kpi.substring(0, 2) !== '09') {
      this.req.getCityKpiActions(this.city, this.kpi).subscribe((res) => {
        this.actions = res;
        this.actions.forEach(element => {
          element.expanded = false;
        });
      });
    }
    this.preloadImage(this.safeBaseUrl);
    this.preloadImage(this.safeAllUrl);
    this.preloadImage(this.safeTableUrl);
  }


  onClick(action) {
    this.actions.forEach((element) => {
      element.expanded = element.Actions === action ? !element.expanded : false;
      this.kpiScores = [];
      this.barChartData = [];
    });

    this.actionName = action;

    this.req.getKpiActionEvaluationScore(this.city, this.kpi, this.actionName).subscribe((res) => {
      this.scores = res;

      setTimeout(() => {
        const baseline = this.scores[0].Baseline_score.length ? this.scores[0].Baseline_score : [0];
        const m24 = this.scores[0].M24_score.length ? this.scores[0].M24_score : [0];
        const m36 = this.scores[0].M36_score.length ? this.scores[0].M36_score : [0];
        const m48 = this.scores[0].M48_score.length ? this.scores[0].M48_score : [0];

        const chartData = [];
        if (this.scores[0].Keys.length === 0) {
          chartData.push({
            label: 'KPI',
            data: [baseline[0], m24[0], m36[0], m48[0]]
          });
        } else {
          for (let i = 0; i < this.scores[0].Keys.length; i++) {
            chartData.push({
              label: this.scores[0].Keys[i],
              data: [
                baseline[i] || 0,
                m24[i] || 0,
                m36[i] || 0,
                m48[i] || 0
              ]
            });
          }
        }

        this.barChartData.push({
          barchartDataObject: chartData,
          barChartOptions: this.is43 ? this.barChartOption43 : this.barChartOptions
        });
      }, 400);
    });
  }


  onClickAgain(category) {
    this.data.forEach(element => {
      if (element.Kpi_Cat == category) {
        element.expanded = !element.expanded;
      }
      else {
        element.expanded = false;
        this.kpis = [];
      }
    })
    for (let i = 0; i < this.data.length; i++) {
      this.kpis.push(this.data[i].Kpis);
    }
  }

  onKpiClickAgain(kpi) {
    const kpiAgain = kpi
    this.router.navigateByUrl('/').then(() => { this.router.navigateByUrl(`Evaluation/KPI/${kpi.substring(0, 2)}`, { state: { city: this.city, kpi: kpiAgain, user: this.username } }) });
  }

  onBaseline() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/Baseline`, { state: { city: this.city, kpi: this.kpi, action: this.actionName, step: 'Baseline', is63: this.is63.Baseline, user: this.username } });
  }

  onM24() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/M24`, { state: { city: this.city, kpi: this.kpi, action: this.actionName, step: 'M24', is63: this.is63.M24, user: this.username } });
  }

  onM36() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/M36`, { state: { city: this.city, kpi: this.kpi, action: this.actionName, step: 'M36', is63: this.is63.M36, user: this.username } });
  }

  onM42() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/M42`, { state: { city: this.city, kpi: this.kpi, action: this.actionName, step: 'M42', is63: this.is63.M42, user: this.username } });
  }

  onInfo() {
    const dialogRef = this.dialog.open(KpiDialogComponent, {
      autoFocus: false,
      disableClose: false,
      data: { info: this.scores[0].Info }
    });

    dialogRef.afterOpened().subscribe(() => {
      const listElement = document.querySelector('.kpi-list') as HTMLElement;
      if (listElement) {
        listElement.style.visibility = 'hidden';
        listElement.style.opacity = '0';
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      const listElement = document.querySelector('.kpi-list') as HTMLElement;
      if (listElement) {
        listElement.style.visibility = 'visible';
        listElement.style.opacity = '1';
      }
    });
  }

  preloadImage(url: string) {
    const img = new Image();
    img.src = url;

    // Image loaded successfully
    img.onload = () => {
      this.onImageLoad();
    };
  }

  onImageLoad() {
    this.imageLoadCount++;

    if (this.imageLoadCount === this.totalImages) {
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    }
  }


}
